import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Skeleton component matching shadcn/ui design tokens.
 * Uses bg-muted with animate-pulse for consistent loading states.
 */
const Skeleton = ({ className, ...props }) => {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
};

export default Skeleton;
